var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxCrownOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32184 3.45273C8.24832 3.34771 8.1282 3.28516 8 3.28516C7.8718 3.28516 7.75168 3.34771 7.67816 3.45273L5.19669 6.99769L3.17065 4.97165C3.05829 4.8593 2.88932 4.82568 2.74252 4.88649C2.59572 4.9473 2.5 5.09055 2.5 5.24944V10.3566C2.5 10.7733 2.66556 11.173 2.96026 11.4677C3.25496 11.7625 3.65466 11.928 4.07143 11.928H11.9286C12.3453 11.928 12.745 11.7625 13.0397 11.4677C13.3344 11.173 13.5 10.7733 13.5 10.3566V5.24944C13.5 5.09055 13.4043 4.9473 13.2575 4.88649C13.1107 4.82568 12.9417 4.8593 12.8293 4.97165L10.8033 6.99769L8.32184 3.45273Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxCrownOutline);
export default __webpack_public_path__ + "static/media/icon_16px_crown_outline.37bc3155ff9cd77b7044475dbfcc6362.svg";
export { ForwardRef as ReactComponent };